import React from 'react'
import PropTypes from 'prop-types'

import styles from './RadioButton.module.scss'
import { ReactComponent as RadioButtonSelected } from '../assets/icons/radio-button-selected.svg'
import { ReactComponent as RadioButtonUnselected } from '../assets/icons/radio-button-unselected.svg'

const RadioButton = ({ checked, id, label, onChange }) => {
  const button = checked ? <RadioButtonSelected /> : <RadioButtonUnselected />

  return (
    <label className={styles.radioButton}>
      <span className={styles.buttonContainer}>{button}</span>
      <input
        checked={checked}
        hidden={true}
        id={id}
        name={id}
        onChange={onChange}
        type="radio"
        value={id}
      />
      <span className={styles.label}>{label}</span>
    </label>
  )
}

RadioButton.defaultProps = {
  checked: false,
  id: '',
  label: '',
  onChange: () => {},
}

RadioButton.propTypes = {
  checked: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
}  

export default RadioButton
